import { LocationSlice } from '../slice'
import { getBulkData } from './getBulkData'
import { getData } from './getData'

export const LocationActions = {
  ...LocationSlice.actions,
  getData,
  getBulkData,
}
